export default "__VITE_ASSET__0lEy8sW0__"